<template>
    		<!-- Pricing  Plan -->
		<section class="pricing-plan"> 
			<div class="container"> 
				<div class="row">
					<div class="col-md-12 text-center">
						<div class="section-heading heading-five price-head-five aos" data-aos="fade-up">
							<h2>Our Pricing  Plan</h2>
						</div>	
					</div>
				</div>
				<div class="row">
				    <div class="col-lg-3 d-flex col-md-6">
					    <div class="price-card price-three price-five flex-fill">
							<div class="price-head">
								<div class="price-level">
									<h6>Intro</h6>
								</div>						
							</div>	
							<div class="price-body">
								<ul>
									<li class="active">Upload Video up to 720p Resolution</li>
									<li class="inactive">Attachment & Post Scheduling</li>
									<li class="inactive">Set your rates</li>
									<li class="inactive">Exclusive Deals</li>
									<li class="inactive">Advanced Statistics</li>
								</ul>
								<h4>$123 <span>/ month</span></h4>		
								<div>
									<router-link to="login" class="btn viewdetails-btn">Choose Plan <i class="feather-arrow-right ms-2"></i></router-link>
								</div>							
							</div>							
					    </div>
					</div>
					<div class="col-lg-3 d-flex col-md-6">
					    <div class="price-card price-three price-five flex-fill">
							<div class="price-head">
								<div class="price-level">
									<h6>Basic</h6>
								</div>								
							</div>	
							<div class="price-body">
								<ul>
									<li class="active">Upload Video up to 720p Resolution</li>
									<li class="active">Attachment & Post Scheduling</li>
									<li class="active">Set your rates</li>
									<li class="inactive">Exclusive Deals</li>
									<li class="inactive">Advanced Statistics</li>
								</ul>
								<h4>$123 <span>/ month</span></h4>		
								<div>
									<router-link to="login" class="btn viewdetails-btn">Choose Plan <i class="feather-arrow-right ms-2"></i></router-link>
								</div>							
							</div>							
					    </div>	
					</div>
					<div class="col-lg-3 d-flex col-md-6">
					    <div class="price-card price-three price-five flex-fill active">
							<div class="price-head">
								<div class="price-level">
									<h6>Popular</h6>
									<span>Save $40</span>
								</div>								
							</div>	
							<div class="price-body">
								<ul>
									<li class="active">Upload Video up to 720p Resolution</li>
									<li class="active">Attachment & Post Scheduling</li>
									<li class="active">Set your rates</li>
									<li class="active">Exclusive Deals</li>
									<li class="inactive">Advanced Statistics</li>
								</ul>
								<h4>$123 <span>/ month</span></h4>	
								<div>
									<router-link to="login" class="btn viewdetails-btn">Choose Plan <i class="feather-arrow-right ms-2"></i></router-link>
								</div>								
							</div>							
					    </div>
					</div>
					<div class="col-lg-3 d-flex col-md-6">
					     <div class="price-card price-three price-five flex-fill">
							<div class="price-head">
								<div class="price-level">
									<h6>Enterprise</h6>
								</div>								
							</div>	
							<div class="price-body">
								<ul>
									<li class="active">Upload Video up to 720p Resolution</li>
									<li class="active">Attachment & Post Scheduling</li>
									<li class="active">Set your rates</li>
									<li class="active">Exclusive Deals</li>
									<li class="active">Advanced Statistics</li>
								</ul>
								<h4>$123 <span>/ month</span></h4>		
								<div>
									<router-link to="login" class="btn viewdetails-btn">Choose Plan <i class="feather-arrow-right ms-2"></i></router-link>
								</div>							
							</div>							
					    </div>
					</div>
				</div>
			</div>
		</section>
		<!-- /Pricing  Plan -->
    </template>